import { Loading } from 'element-ui';

export default[
    {
        show(row,extra){
            return true
        },
        tag:'my-btn',
        type:'detail',
        text:'详情',
        click(row,extra){
            this.goto({
                path: '/bidding/projectflow/dingbiao/zhongbiaogg/jsgc/detail',
                query: {
                    id: row.ggcode,
                    type:'1'
                }
            });
        }
    },{
        show(row,extra){
            return row.shbj==='1'
        },
        tag:'el-button',
        type:'text',
        icon: 'el-icon-check',
        text: '通过',
        click(row,extra){
            var that = this
            that.$post(`${this.getGetters('mngUrl')}/manage/business/auditzbjggg/sh.json`, {
                rows:row.ggcode
            }, (data, res) => {
                ShowMsg('审核成功,已通过', 'success');
                that.$emit('reload')
            });
        }
    },{
        show(row,extra){
            return row.shbj==='1'
        },
        tag:'el-button',
        type:'text',
        icon: 'el-icon-close',
        text: '退回',
        click(row,extra){
            var that = this
            ShowConfirm('是否确定退回公告？', 'danger', () => {
                that.$post(`${this.getGetters('mngUrl')}/manage/business/auditzbjggg/sh2.json`, {
                    rows:row.ggcode
                }, (data, res) => {
                    ShowMsg('审核成功,已退回', 'success');
                    that.$emit('reload')
                });
            });
        }
    },{
        show(row,extra){
            return row.shbj==='6'
        },
        tag:'el-button',
        type:'text',
        icon: 'el-icon-refresh-right',
        text: '查看同步状态',
        click(row,extra){
            // 加载
            var loadingInstance = Loading.service({
                body : true,
                text : '加载中'
            });
            this.$ajax({
                url:`${this.getGetters('mngUrl')}/manage/business/auditzbjggg/getTbzt.json`,
                data:{
                    ggcode:row.ggcode
                },
                callback:(data, res)=>{
                    ShowMsgBox(res.msg,'info')
                },
                complete:()=>{
                    loadingInstance.close();
                }
            })
        }
    },
]